import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { forbiddenHtmlTags } from './forbidden-html-tags';
import { forbiddenWords } from './forbidden-words';

/**
 * Validator function to check if the control's value contains any forbidden HTML tags or forbidden words.
 *
 * @returns A `ValidatorFn` that returns a validation error if forbidden HTML tags or forbidden words are found, otherwise `null`.
 */
export function forbiddenContentValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    //const forbiddenWords = ['--', '|'];
    const value: string = control.value || '';
    if (forbiddenWords.some((word: string) => value.includes(word.toLowerCase()))) {
      return { forbiddenContent: true };
    }
    const htmlTagRegex = /<\/?(!?[a-z][a-z0-9]*)\b[^>]*>/gi; // Matches any HTML tags

    const htmlTagsArray = Array.from(value.matchAll(htmlTagRegex)).map(match => match[1].toLowerCase()); // map will extracts the tag name from each

    const distinctTags = [...new Set(htmlTagsArray)];
    if (distinctTags.some(tag => forbiddenHtmlTags.includes(tag))) {
      return { forbiddenContent: true };
    }
    return null;
  };
}
